/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import { createApiResponseSchema, type IAPI } from '../../apiResponse';
import { type IMovieRatingData, movieRatingDataSchema } from '../movie-rating-schema';

export const rateMovieV1ResponseSchema = createApiResponseSchema(
  movieRatingDataSchema,
) as z.ZodSchema<IAPI<IMovieRatingData>>;

export type IRateMovieV1Response = IAPI<IMovieRatingData>;
